// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"0cbb1755","107":"be881b31","250":"c9a58a0d","402":"d930e030","570":"dafc3c29","584":"1700c5d9","700":"f29db91f","910":"ee493482"}[chunkId] + ".chunk.js";
};